import request from "@/utils/request";
export function getThread(tid) {
  return request({
    url: "/v6/threads/" + tid,
    method: "get"
  });
}
export function getComments(params) {
  return request({
    url: "/v6/comments/",
    method: "get",
    params
  });
}
